import { ref } from 'vue'
import { unSubscribeFromABotCall } from '@/plugins/initRealTimeSdk'
import { isRTL } from '@/composables/useDirection'

export const CHAT_WIDTH = 360
export const chats = ref<Chat[]>([])
const zIndexBase = 1000
const yBase = 40

export interface Chat {
    id: string
    z: number
    y: number
    x: number
    callId: string
    botId: number
}
export function addChat (botId: number, callId: string): void {
    chats.value.push({
        id: callId,
        z: zIndexBase,
        y: yBase + 10,
        x: getX(),
        callId: callId,
        botId,
    })
}

export function getX () {
    if (isRTL.value) {
        return CHAT_WIDTH + ((chats.value?.length ?? 0) * 20)
    }
    return (chats.value?.length ?? 0) * 20
}

export function isSubscribed (id: string) {
    return !!chats.value.find(chat => chat.id === id)
}

export async function removePopup (id: string, botId: number) {
    chats.value = chats.value.filter((p) => p.id !== id)
    await unSubscribeFromABotCall(botId, id)
}
